import ReactDOM from 'react-dom/client'
import { RecoilRoot } from 'recoil'
import RecoilNexus from 'recoil-nexus'
import ThemeProvider from 'theme/ThemeProvider'
import App from './App'
import AlertContainer from 'components/Alert/AlertContainer'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <RecoilRoot>
    <AlertContainer />
    <RecoilNexus />

    <ThemeProvider>
      <App></App>
    </ThemeProvider>
  </RecoilRoot>
)
